

const SidebarData = [
    {
        label: "Menu",
        isMainMenu: true,
    },
    // {
    //     label: "Lab",
    //     icon: "mdi mdi-account-convert-outline",
    //     url: "/lab",
    //     isHasArrow: true,
    //     role_id:3
    // },
    // {
    //     label: "Medicines",
    //     icon: "mdi mdi-account-convert-outline",
    //     url: "/medicines",
    //     isHasArrow: true,
    //     role_id:4
    // },
    
    {
        label: "Users",
        icon: "mdi mdi-account-circle-outline",
        isHasArrow:false,
        role_id:1,
        subItem: [
            // { sublabel: "Dashboard", link: "/dashboard"},
            { sublabel: "Admin User", link: "/users" },
            { sublabel: "Job Seakers", link: "/job-seakers"},
            { sublabel: "Jobs", link: "/jobs"},
            { sublabel: "Job Applications", link: "/job-applications"}
        ],
    },
    // {
    //     label: "Config",
    //     icon: "mdi mdi-account-circle-outline",
    //     isHasArrow:false,
    //     role_id:1,
    //     subItem: [
    //         { sublabel: "Lab Diagnosis ", link: "/labdiagnosis" },
    //         { sublabel: "Medicines Details", link: "/medicine-details" },
    //     ],
    // },
    // {
    //     label: "Patients",
    //     icon: "mdi mdi-account-convert-outline",
    //     url: "/patients",
    //     isHasArrow: true,
    //     role_id:2
    // },
]
export default SidebarData;